import React, { useState, useContext, useEffect } from 'react';
import Table from "../../components/Table"
import StateContext from '../../helpers/ContextState';
import Config from '../../helpers/Config';
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";

const App = (props) => {
  const context = useContext(StateContext);

  const [param, setParam] = useState({
    agrupar_proveedor_pago: 1
  });

  const [inputs, setInputs] = useState({
    fecha_inicio: "",
    fecha_fin: "",
    pago_fecha_inicio: "",
    pago_fecha_fin: "",
    semestre: "",
    proveedor_id: "",
    op_inventario_items_id: ""
  });

  const [inputs2, setInputs2] = useState({});
  const [filter, setFilter] = useState("");
  const [reset, setReset] = useState(false);

  useEffect(() => {
    setParam(prev => ({
      ...prev,
      agrupar_proveedor_pago: 1,
      ...inputs,
      ...inputs2,
    }));
  }, [inputs, inputs2]);

  const onChangeCustom = (e) => {
    const { name, value } = e.target;
    setInputs({ ...inputs, [name]: value });
    if (name === "filter") setFilter(value);
  };

  const tds = [
    { label: "Cliente",    value: "cliente_nombre",        className: "text-left",   classNameHeader: "text-center" },
    { label: "NIT",        value: "cliente_cedula",         className: "text-left",   classNameHeader: "text-center" },
    { label: "Dirección",  value: "cliente_direccion",      className: "text-left",   classNameHeader: "text-center" },
    { label: "Tipo",       value: "es_asociado_string",     className: "text-center", classNameHeader: "text-center" },
    { label: "Semestre",   value: "semestre",               className: "text-center", classNameHeader: "text-center" },
    { label: "Año",        value: "anio",                   className: "text-center", classNameHeader: "text-center" },
    { label: "Producto",   value: "producto_nombre",        className: "text-left",   classNameHeader: "text-center" },
    { total: true, label: "Cantidad",    value: "cantidad_total_format",   className: "text-center", classNameHeader: "text-center" },
    { total: true, label: "Peso",        value: "peso_total_format",       className: "text-center", classNameHeader: "col text-center" },
    { total: true, label: "Subtotal",    value: "subtotal_sin_imp_string", className: "text-center", classNameHeader: "col text-center" },
    { total: true, label: "IVA",         value: "iva_total_string",        className: "text-center", classNameHeader: "col text-center" },
    { total: true, label: "Reteiva",     value: "calculo_reteiva",         className: "text-center", classNameHeader: "col text-center" },
    { total: true, label: "Reteica",     value: "calculo_reteica",         className: "text-center", classNameHeader: "col text-center" },
    { total: true, label: "Retefuente",  value: "calculo_retefuente",      className: "text-center", classNameHeader: "col text-center" },
    { total: true, label: "P. Total",    value: "total_string",            className: "text-center", classNameHeader: "col text-center" },
    {
      label: "Acciones",
      value: "events",
      className: "text-center",
      classNameHeader: "text-center",
      icons: [
        {
          label: "Ver detalle",
          icon: <FontAwesomeIcon icon={faEye} />,
          NavLink: NavLink,
          url: "/Informes/InformesMediosMagneticosVentas/Detalle/",
        }
      ]
    }
  ];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <Table
            customFiltersMediosMagneticosVentas={true}
            total={true}
            toExport={Config.ConfigApirest + 'Excel/Informes/ListadoMediosMagneticosVentasExcel/token:' + context.user.token}
            toPDF={Config.ConfigApirest + 'PDF/Informes/ListadoMediosMagneticosVentas/' + context.user.token}
            td={tds}
            modelo="Informes"
            metodo="ListadoMediosMagneticosVentas"
            limit="20"
            params={param}
            totalizacion={true}
            inputs={inputs}
            setInputs={setInputs}
            inputs2={inputs2}
            setInputs2={setInputs2}
            filter={filter}
            reset={reset}
            onChangeCustom={onChangeCustom}
          />
        </div>
      </div>
    </div>
  );
}

export default App;
